"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebCustomerOrdersRouter = void 0;
const core_1 = require("@ts-rest/core");
const shared_1 = require("../../../shared");
const web_customer_orders_schema_1 = require("./web.customer-orders.schema");
const web_orders_schema_1 = require("./web.orders.schema");
const c = (0, core_1.initContract)();
exports.WebCustomerOrdersRouter = c.router({
    create: {
        method: 'POST',
        path: '/create',
        body: web_customer_orders_schema_1.WebContractCreateOrderRequestSchema,
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(web_orders_schema_1.WebContractCreateOrderResponseSchema) },
    },
    get: {
        method: 'GET',
        path: '/:orderId',
        pathParams: web_orders_schema_1.WebContractOrderIdPathParamsSchema,
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(web_customer_orders_schema_1.WebContractGetOrderResponseSchema) },
    },
    list: {
        method: 'GET',
        path: '/',
        query: web_customer_orders_schema_1.WebContractListOrdersQueryParamsSchema,
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(web_customer_orders_schema_1.WebContractListOrdersResponseSchema) },
    },
    listPurchaseHistory: {
        method: 'GET',
        path: '/history',
        query: web_customer_orders_schema_1.WebContractListOrdersQueryParamsSchema,
        responses: { 200: (0, shared_1.createSuccessResponseSchema)(web_customer_orders_schema_1.WebContractListPurchaseHistoryResponseSchema) },
    },
}, { pathPrefix: '/orders/customers' });
